import { useMemo } from "react";
import useAuthUser from "./authUser";
import {
    authProtectedRoutesForAdmin,
    authProtectedRoutesForUnregistered,
    authProtectedRoutesForUser,
    authProtectedRoutesForDealer,
    pageNotFoundRoute, publicRoutes
} from "../../routes";

const useRoutesByRole = () => {
    const { isAuthUserNotRegistered, isAdmin, isUser, isDealer } = useAuthUser();

    const authProtectedRoutes = useMemo(() => {
        if (isAdmin) {
            return authProtectedRoutesForAdmin;
        } else if (isDealer) {
            return authProtectedRoutesForDealer;
        } else if (isUser) {
            return authProtectedRoutesForUser;
        } else if (isAuthUserNotRegistered) {
            return authProtectedRoutesForUnregistered;
        }

        return [pageNotFoundRoute];
    }, [isAuthUserNotRegistered, isAdmin, isUser, isDealer]);

    const authProtectedRoutesForNonRegistered = useMemo(() => {
        if (isAuthUserNotRegistered) {
            return authProtectedRoutesForUnregistered;
        }

        return [];
    }, [isAuthUserNotRegistered, isAdmin, isUser, isDealer]);

    return {
        publicRoutes,
        authProtectedRoutes,
        authProtectedRoutesForNonRegistered,
    };
};

export default useRoutesByRole;
